var map = {
	"./challenge_A_008FF5.png": 60087,
	"./donation_A_00315C.png": 90995,
	"./donation_A_008FF5.png": 99758,
	"./donation_A_F9F6F3.png": 84905,
	"./letter_A_00315C.png": 66621,
	"./letter_A_008FF5.png": 30128,
	"./letter_A_F9F6F3.png": 21367,
	"./letter_B_00315C.png": 85336,
	"./letter_B_008FF5.png": 97469,
	"./letter_B_F9F6F3.png": 80010,
	"./letter_C_00315C.png": 40367,
	"./letter_C_008FF5.png": 52442,
	"./letter_C_F9F6F3.png": 40701,
	"./pack_A_00315C.png": 22328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79431;